var exports = {
  "nB": "Body__y-AWPC",
  "OS": "Metadata__KdFgIV",
  "FP": "MetadataText__ZEFGml",
  "An": "MarkdownContent__0zeQH4",
  "mW": "HTMLPreview__MYVVnz",
  "cy": "HTMLPreviewActive__SHjfu3",
  "L5": "HTMLPreviewAttribution__-z_Uiw",
  "di": "HTMLPreviewFrame__0T3Ap6",
  "R_": "HTMLSource__y8M6xn",
  "sm": "HTMLPreviewControls__TMznnA",
  "kT": "HTMLPreviewWarning__HgWYKQ",
  "h2": "HTMLPreviewSettings__ejuDoJ",
  "RK": "HTMLPreviewPreference__pX1iam",
  "m2": "HTMLPreviewToggle__uJ8lX2",
  "Bc": "HTMLPreviewSettingsDescription__m37UWy",
  "hr": "PlainBody__It2eLJ",
};

module.exports = exports;
